import React, { Component } from 'react'
import moment from 'moment'
import queryString from 'query-string'
import TimeInput from 'material-ui-time-picker'
import NumberFormat from 'react-number-format'
import _ from 'lodash'
import history from '../history'
import './styles.scss'
import { defaultSchedule, editScheduleHeadings } from '../../constants/common'

class EditeSchedule extends Component {
  constructor() {
    super()
    this.state = {
      title: 'Home',
      titleImage: '',
      helpText: '',
      fromTime: moment(),
      toTime: moment(),
      fromFormat: 'am', // Time format AM PM
      toFormat: 'am', // Time format AM PM
      schedules: [],
      dayOfWeek: 0,
      query: {}, // querystring
      error: ''
    }
    this.setAMPM = this.setAMPM.bind(this)
  }

  componentWillMount() {
    const { location, fetchRooms } = this.props
    // Fetch rooms from API
    fetchRooms()
    
    const time = queryString.parse(location.search)
    // Set from and to time for the home schedules according to type
    this.setDefaultTimeFromQueryParams(time)

     // Set various states for the home schedules according to type
    const headings = editScheduleHeadings[time.type] // type = home/home2/away/sleep
    this.setState({
      query: time,
      dayOfWeek: parseInt(time.dayOfWeek, 10),
      title: headings.title,
      titleImage: headings.titleImage,
      helpText: headings.helpText
    })
  }

  componentWillReceiveProps(np) {
    const { setScheduleSuccess, setSchedule } = np
    if (setScheduleSuccess) {
      // Call setSchedule api and will always pass first element from the sliced data, till it gets empty
      const schedules = _.cloneDeep(this.state.schedules)
      schedules.splice(0, 1)
      this.setState({ schedules }, () => {
        if (schedules.length === 0) {
          // return back to privious page on api success
          history.goBack()
        } else {
          setSchedule(_.first(this.state.schedules))
        }
      })
    }
  }

  componentWillUnmount() {
    const { clearCozyProps } = this.props
    // Reset all the edit schedule props on component unmount
    clearCozyProps()
  }
  // Capture querystring params in state
  setDefaultTimeFromQueryParams(time) {
    this.setState({
      fromTime: moment(time.from, 'hh:mm').format('hh:mm a'),
      toTime: moment(time.to, 'hh:mm').format('hh:mm a'),
      fromFormat: moment(time.from, 'hh:mm').format('a'),
      toFormat: moment(time.to, 'hh:mm').format('a')
    })
  }
  // According to click set am/pm value for from and to time
  setAMPM(type) {
    if (type === 'from') {
      this.setState({
        fromTime: moment(this.state.fromTime, 'hh:mm a').add(12, 'hours').format('hh:mm a'),
        fromFormat: this.state.fromFormat === 'am' ? 'pm' : 'am'
      })
    } else {
      this.setState({
        toTime: moment(this.state.toTime, 'hh:mm a').add(12, 'hours').format('hh:mm a'),
        toFormat: this.state.toFormat === 'am' ? 'pm' : 'am'
      })
    }
  }

  onInputFromChange(e) {
    // Validate the input from time
    this.setState({ fromTime: `${e.target.value} ${this.state.fromFormat}` }, () => {
      this.reAdjustTime(this.state.fromTime, 'fromTime', 'fromFormat')
    })
  }

  onInputToChange(e) {
    // Validate the input to time
    this.setState({ toTime: `${e.target.value} ${this.state.toFormat}` }, () => {
      this.reAdjustTime(this.state.toTime, 'toTime', 'toFormat')
    })
  }
  // Validation for incorrect time values and set those to correct
  reAdjustTime(value, type, format) {
    const time = this.state[type] // type = fromTime/toTime
    const ampm = this.state[format] // format = fromFormat/toFormat

    const factorSpace = parseInt(value.split('')[0], 10) // first part of the time
    const factor = parseInt(value.split(':')[1], 10) // second part of time
    
    if (factor > 59) { // Auto correct minutes
      this.setState({ [type]: `${time.split(':')[0]}:59 ${ampm}` })
    }
    if (factorSpace > 1) { // Auto correct Hours
      this.setState({ [type]: `0${time.split('')[0]}` })
    }
  }
  // On foucus out validates the from and to time of input box
  onBlur() {
    // if the time is invalid set the default time
    if (!moment(this.state.fromTime, 'hh:mm a').isValid() || !moment(this.state.toTime, 'hh:mm a').isValid()) {
      this.setDefaultTimeFromQueryParams(this.state.query)
    }
  }

  mobileFromTimeChange(time) {
    this.setState({ fromTime: moment(time, 'hh:mm a').format('hh:mm a') })
  }

  mobileToTimeChange(time) {
    this.setState({ toTime: moment(time, 'hh:mm a').format('hh:mm a') })
  }
  // Trigger save process for the schedule
  saveSchedules() {
    this.setScheduleCall(this.state.query.roomId)
  }
  // API call
  setScheduleCall() {
    const { setSchedule, rooms } = this.props
    const { dayOfWeek, fromTime, toTime, fromFormat, toFormat, query } = this.state
    
    const schedules = []

    const schedulesDefault = { ...defaultSchedule, dayOfWeek: dayOfWeek }
    
    const room = rooms.filter(room => room.id === parseInt(query.roomId, 10))[0]

    let schedule = room.schedules.filter(schedule => schedule.dayOfWeek === dayOfWeek)[0]

    schedule = schedule ? schedule : schedulesDefault

    if (query.type === 'home') { // Set current day home1 and away
      schedules.push({
        ...schedule, id: query.roomId,
        home1: moment(`${fromTime} ${fromFormat}`, 'hh:mm a').format('HH:mm'),
        away: moment(`${toTime} ${toFormat}`, 'hh:mm a').format('HH:mm')
      })
    } else if (query.type === 'home2') { // Set current day home2 and sleep
      schedules.push({
        ...schedule, id: query.roomId,
        home2: moment(`${fromTime} ${fromFormat}`, 'hh:mm a').format('HH:mm'),
        sleep: moment(`${toTime} ${toFormat}`, 'hh:mm a').format('HH:mm')
      })
    } else if (query.type === 'away') { // Set current day away and home 2
      schedules.push({
        ...schedule, id: query.roomId,
        away: moment(`${fromTime} ${fromFormat}`, 'hh:mm a').format('HH:mm'),
        home2: moment(`${toTime} ${toFormat}`, 'hh:mm a').format('HH:mm'),
      })
    } else if (query.type === 'sleep') { // Set current day sleep time and next day home time schedule during sleep time
      schedules.push({ ...schedule, id: query.roomId, sleep: moment(`${fromTime} ${fromFormat}`, 'hh:mm a').format('HH:mm') })
    }

    this.setState({ schedules }, () => {
      setSchedule(_.first(schedules))
    })
  }

  render() {
    const { toTime, fromTime, fromFormat, toFormat, titleImage, helpText } = this.state
    const { rooms } = this.props
    return (
      <div>
        <main id="EditeSchedule">
          <div className="wrapper">
            <header className="header display-flex">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 col-md-12 align-middle d-flex align-items-center justify-content-center">
                    <h3 className="secondary-title">Edit Time to Schedule</h3>
                    <a className="close" onClick={() => history.goBack()}>
                      <img alt="" src="img/close-icon.png" />
                    </a>
                  </div>
                </div>
              </div>
            </header>
            <div className="container-inner">
              <div className="container">
                <div className="col-md-12 text-center">
                  <div className="list-icon-left">
                    <a>
                      <img alt="" src={titleImage} /> {this.state.title}
                    </a>
                  </div>
                  <small className="text-gray">{helpText}</small>
                </div>
                <div className="edit__schedule d-flex flex-column align-items-center justify-content-center">
                  <div className="row">
                    <div className="col-md-12">
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">
                          <div className="edit-time-box">
                            {this.state.query.type !== 'sleep' ? ( <h4 className="title">From</h4> ) : ('')}
                            <div className="edit-time-box-input">
                             <div className="d-none d-md-block d-lg-block">
                              <NumberFormat
                                format="##:##"
                                value={fromTime}
                                onFocus={() => this.setState({ fromTime: '' })}
                                onChange={e => this.onInputFromChange(e)}
                                onBlur={() => this.onBlur()}
                              />
                                <time>
                                  <small className="text-pm" onClick={() => this.setAMPM('from')}>
                                    {fromFormat}
                                  </small>
                                </time>
                             </div>
                             <div className="d-block d-md-none d-lg-none"> 
                              <TimeInput
                                mode="12h"
                                value={(new Date(moment(fromTime, 'hh:mm a'))).toString() === 'Invalid Date' ? new Date(moment()) : new Date(moment(fromTime, 'hh:mm a'))}
                                onChange={(time) => this.mobileFromTimeChange(time)}
                              />
                              </div>                         
                            </div>
                          </div>
                          {this.state.query.type !== 'sleep' ? ( 
                              <div className="edit-time-box">
                                <h4 className="title">To</h4>
                                <div className="edit-time-box-input">
                                  <div className="d-none d-md-block d-lg-block">
                                    <NumberFormat
                                      format="##:##"
                                      value={toTime}
                                      onFocus={() => this.setState({ toTime: '' })}
                                      onChange={e => this.onInputToChange(e)}
                                      onBlur={() => this.onBlur()}
                                    />
                                      <time>
                                        <small className="text-pm" onClick={() => this.setAMPM('to')}>
                                          {toFormat}
                                        </small>
                                      </time>                                 
                                  </div>
                                  <div className="d-block d-md-none d-lg-none">
                                    <TimeInput
                                      mode="12h"
                                      value={(new Date(moment(toTime, 'hh:mm a'))).toString() === 'Invalid Date' ? new Date(moment()) : new Date(moment(toTime, 'hh:mm a'))}
                                      onChange={(time) => this.mobileToTimeChange(time)}
                                    />
                                  </div>
                                </div>
                              </div>
                          ) : ('')}
                        </li>
                      </ul>
                      <footer>
                        <p>{this.state.error}</p>
                        <button type="button" className="btn btn-primary btn-lg btn-block" disabled={!rooms} onClick={() => this.saveSchedules()}>
                          Save
                        </button>
                      </footer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    )
  }
}
export default EditeSchedule



// WEBPACK FOOTER //
// ./src/views/EditSchedule/component.js